import { useContext } from 'react';
import { WixDesignSystemDefaultPropsContext } from './context';
import { resolveDefaultProps } from './resolveDefaultProps';
import {
  ProviderDefaultPropSupportedComponentName,
  ProviderDefaultPropSupportedComponents,
} from './types';

export function useDefaultProps<
  K extends ProviderDefaultPropSupportedComponentName,
  P extends ProviderDefaultPropSupportedComponents[K],
>(componentKey: K, props: P): P {
  const defaults = useContext(WixDesignSystemDefaultPropsContext)[componentKey];
  return resolveDefaultProps(defaults as Partial<P>, props);
}
